import React from "react";
import { message, Popconfirm } from "antd";
import { gql, useMutation } from "@apollo/client";

const ACTIVATEUSER = gql`
  mutation setUserActive($id: ID!) {
    setUserActive(id: $id)
  }
`;
function ActivateUser({ id, name, children, onActivateUser }) {
    const [runActivateUser, setActivateUser] = useMutation(ACTIVATEUSER, {
        onCompleted({ setUserActive }) {
          if (setUserActive) {
            message.success(`کاربر ${name ? name : ""} فعال شد.`);
            onActivateUser();
          } else {
            message.error("متاسفانه مشکلی پیش آمده! کاربر فعال نشد.");
          }
        },
        onError() {
          message.error("متاسفانه مشکلی پیش آمده! کاربر فعال نشد.");
        },
      });
      const doActivateUser = () => {
        runActivateUser({
          variables: { id },
        });
      };
    return (
        <>
        <Popconfirm
          title={`فعال کردن ${name ? name : "کاربر"}?`}
          okText="فعال کردن"
          cancelText="خیر"
          onConfirm={doActivateUser}
        >
          <span>{children}</span>
        </Popconfirm>
      </>
    );
}

export default ActivateUser;